__turbopack_context__.v({
  "accordion": "ServicesList-module-scss-module__bd2d8a__accordion",
  "accordion-trigger-icon": "ServicesList-module-scss-module__bd2d8a__accordion-trigger-icon",
  "child-item-link": "ServicesList-module-scss-module__bd2d8a__child-item-link",
  "child-item-link-icon": "ServicesList-module-scss-module__bd2d8a__child-item-link-icon",
  "child-item-parent-link": "ServicesList-module-scss-module__bd2d8a__child-item-parent-link",
  "child-items": "ServicesList-module-scss-module__bd2d8a__child-items",
  "content": "ServicesList-module-scss-module__bd2d8a__content",
  "desktop": "ServicesList-module-scss-module__bd2d8a__desktop",
  "expand-all-button": "ServicesList-module-scss-module__bd2d8a__expand-all-button",
  "grid": "ServicesList-module-scss-module__bd2d8a__grid",
  "indicator": "ServicesList-module-scss-module__bd2d8a__indicator",
  "list": "ServicesList-module-scss-module__bd2d8a__list",
  "list-item-link": "ServicesList-module-scss-module__bd2d8a__list-item-link",
  "list-item-link-icon": "ServicesList-module-scss-module__bd2d8a__list-item-link-icon",
  "mobile": "ServicesList-module-scss-module__bd2d8a__mobile",
  "slide-down": "ServicesList-module-scss-module__bd2d8a__slide-down",
  "slide-up": "ServicesList-module-scss-module__bd2d8a__slide-up",
  "trigger": "ServicesList-module-scss-module__bd2d8a__trigger",
});
